var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-fade-transition',{attrs:{"mode":"out-in"}},[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('v-card',[_c('IframeComponent',{attrs:{"url":_vm.iframeUrl}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }